import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

type Props = {
  title: string
  isDisable?: boolean
  className?: string
  onClick: () => void
  id: string
}

export const ProductCardSizeItem: React.FC<Props> = ({
  title,
  isDisable,
  className,
  onClick,
  id,
}) => {
  return (
    <li>
      <Button
        onClick={onClick}
        // ga-tracking-value={`product-card__quick-add-to-cart__${id}__size-${title}`}
        // ga-tracking-label={`Size ${title}`}
        className={cn(
          'relative inset-0 h-9 w-12 cursor-pointer rounded-lg bg-neutral-100 py-2 pt-1.5 text-center font-sans text-base text-neutral-700 hover:bg-neutral-900 hover:text-light lg:bg-light 2xl:w-[52px] 2xl:px-3',
          className,
          isDisable &&
            'pointer-events-none cursor-not-allowed bg-neutral-100/30 text-neutral-300 after:absolute after:left-0 after:top-1/2 after:w-full after:rotate-[158deg] after:border-t-2 after:border-dashed after:border-neutral-200 lg:bg-light'
        )}
      >
        {title}
      </Button>
    </li>
  )
}
